import IconHOC from '../IconHOC';

import { ReactComponent as MinusIcon } from './minus.svg';

export const Minus = IconHOC(MinusIcon);
